export default __webpack_public_path__ + "bd04200.png";